import { cva } from 'class-variance-authority'

export const userDisplayStyles = cva('', {
  variants: {
    layout: {
      standard: 'text-primary min-w-0 w-full flex items-center gap-2',
      'inline-text': 'font-medium',
    },
    size: {
      base: '',
      small: '',
    },
  },
  compoundVariants: [
    { layout: 'standard', size: 'base', class: 'text-base' },
    { layout: 'standard', size: 'small', class: 'text-sm' },
  ],
  defaultVariants: {
    layout: 'standard',
    size: 'base',
  },
})
